import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=2f90cc9d&scoped=true&"
import script from "./CommentDetail.vue?vue&type=script&lang=js&"
export * from "./CommentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&id=2f90cc9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90cc9d",
  null
  
)

export default component.exports